import React, { useState } from 'react';

const LoginPage: React.FC = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const testCredentials = {
    email: 'admin@hvaccrm.com',
    password: 'admin123'
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    setTimeout(() => {
      if (credentials.email === testCredentials.email && credentials.password === testCredentials.password) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userEmail', credentials.email);
        window.location.href = '/dashboard';
      } else {
        setError('Invalid email or password. Please use the test credentials.');
      }
      setLoading(false);
    }, 1000);
  };

  const fillTestCredentials = () => {
    setCredentials(testCredentials);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8f9fa', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '400px', width: '100%' }}>
        <div className="card">
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h2 style={{ color: '#2c3e50', marginBottom: '10px' }}>HVAC CRM</h2>
            <p style={{ color: '#6c757d' }}>Sign in to your account</p>
          </div>

          <div style={{ 
            backgroundColor: '#e3f2fd', 
            padding: '15px', 
            borderRadius: '4px', 
            marginBottom: '20px',
            border: '1px solid #bbdefb'
          }}>
            <p style={{ fontSize: '14px', color: '#1976d2', marginBottom: '10px', fontWeight: 'bold' }}>
              Test Credentials:
            </p>
            <p style={{ fontSize: '13px', color: '#1976d2', margin: '5px 0' }}>
              Email: admin@hvaccrm.com
            </p>
            <p style={{ fontSize: '13px', color: '#1976d2', margin: '5px 0' }}>
              Password: admin123
            </p>
            <button 
              type="button"
              onClick={fillTestCredentials}
              style={{
                background: 'none',
                border: 'none',
                color: '#1976d2',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: '12px',
                marginTop: '5px'
              }}
            >
              Click to fill credentials
            </button>
          </div>

          {error && (
            <div style={{ 
              backgroundColor: '#ffebee', 
              color: '#c62828', 
              padding: '15px', 
              borderRadius: '4px', 
              marginBottom: '20px',
              border: '1px solid #ffcdd2'
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email Address</label>
              <input 
                type="email" 
                name="email"
                value={credentials.email}
                onChange={handleInputChange}
                required 
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input 
                type="password" 
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                required 
                placeholder="Enter your password"
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%', padding: '12px' }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <a 
              href="/"
              style={{ color: '#6c757d', textDecoration: 'none', fontSize: '14px' }}
            >
              ← Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;